// extracted by mini-css-extract-plugin
export default {"Bar":"StatusBar_Bar__AkjOh"};